import { FC } from 'react';
import './specimenCardSkeleton.scss';

const SpecimenCardSkeleton: FC = (): JSX.Element => {
  return (
    <article className="specimen-card-skeleton" aria-label="Loading specimen card">
      <div className="specimen-card-skeleton__image skeleton-shimmer" />
      <div className="specimen-card-skeleton__body">
        <div className="specimen-card-skeleton__name skeleton-shimmer" />
        <div className="specimen-card-skeleton__breed skeleton-shimmer" />
        <div className="specimen-card-skeleton__species skeleton-shimmer" />
        <div className="specimen-card-skeleton__attr skeleton-shimmer" />
        <div className="specimen-card-skeleton__breeder skeleton-shimmer" />
        <div className="specimen-card-skeleton__footer">
          <div className="specimen-card-skeleton__price skeleton-shimmer" />
          <div className="specimen-card-skeleton__stock skeleton-shimmer" />
        </div>
        <div className="specimen-card-skeleton__actions">
          <div className="specimen-card-skeleton__button skeleton-shimmer" />
          <div className="specimen-card-skeleton__button skeleton-shimmer" />
        </div>
      </div>
    </article>
  );
};

export default SpecimenCardSkeleton;
